/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ minute: NonNullable<unknown> }} Countdown_MinuteInputs */

const en_countdown_minute = /** @type {(inputs: Countdown_MinuteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minute}  m`)
};

const ar_countdown_minute = /** @type {(inputs: Countdown_MinuteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minute}  دقيقة`)
};

const de_countdown_minute = /** @type {(inputs: Countdown_MinuteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minute}  m`)
};

const es_countdown_minute = /** @type {(inputs: Countdown_MinuteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minute}  min`)
};

const fr_countdown_minute = /** @type {(inputs: Countdown_MinuteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minute}  min`)
};

const it_countdown_minute = /** @type {(inputs: Countdown_MinuteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minute}  m`)
};

const ja_countdown_minute = /** @type {(inputs: Countdown_MinuteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minute} 分`)
};

const ko_countdown_minute = /** @type {(inputs: Countdown_MinuteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minute} }분`)
};

const pt_br_countdown_minute = /** @type {(inputs: Countdown_MinuteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minute}  m`)
};

const ru_countdown_minute = /** @type {(inputs: Countdown_MinuteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minute}  мин.`)
};

const th_countdown_minute = /** @type {(inputs: Countdown_MinuteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minute}  น.`)
};

const tr_countdown_minute = /** @type {(inputs: Countdown_MinuteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minute}  dk`)
};

const zh_cn_countdown_minute = /** @type {(inputs: Countdown_MinuteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minute}  分`)
};

const zh_tw_countdown_minute = /** @type {(inputs: Countdown_MinuteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minute} 分`)
};

/**
* | output |
* | --- |
* | "{minute} m" |
*
* @param {Countdown_MinuteInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const countdown_minute = /** @type {((inputs: Countdown_MinuteInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Countdown_MinuteInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_countdown_minute(inputs)
	if (locale === "ar") return ar_countdown_minute(inputs)
	if (locale === "de") return de_countdown_minute(inputs)
	if (locale === "es") return es_countdown_minute(inputs)
	if (locale === "fr") return fr_countdown_minute(inputs)
	if (locale === "it") return it_countdown_minute(inputs)
	if (locale === "ja") return ja_countdown_minute(inputs)
	if (locale === "ko") return ko_countdown_minute(inputs)
	if (locale === "pt_br") return pt_br_countdown_minute(inputs)
	if (locale === "ru") return ru_countdown_minute(inputs)
	if (locale === "th") return th_countdown_minute(inputs)
	if (locale === "tr") return tr_countdown_minute(inputs)
	if (locale === "zh_cn") return zh_cn_countdown_minute(inputs)
	return zh_tw_countdown_minute(inputs)
});